import * as React from 'react';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { MultiKeyValueComponent } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { SelectOptionButton } from 'app/components/code-selector/select-option-button';
import { ElementLoader } from 'ui/common/element-loader/element-loader';

export interface MultipleCodeSelectorProps extends MultiKeyValueComponent<number> {
  title: string;
  selectedOptions: ComplexValue<number>[];
  onClose: () => void;
  onCodeSelected: (code: ComplexValue<number>) => void;
  textDone: string;
}

export interface MultipleCodeSelectorState {
  adding: boolean;
}

export class MultipleCodeSelector extends React.Component<MultipleCodeSelectorProps, MultipleCodeSelectorState> {
  public static defaultProps: Partial<MultipleCodeSelectorProps> = {
    loadOptions: {},
    readOnly: false
  };

  public static getDerivedPropsFromState(props:MultipleCodeSelectorProps, state:MultipleCodeSelectorState) {
    return {
      adding: false
    };
  }

  public state: Readonly<MultipleCodeSelectorState> = {
    adding: false
  };

  private onSelectCode = (code: any) => {
    if (!this.state.adding && !!code) {
      this.setState({
        ...this.state,
        adding: true
      }, () => this.props.onCodeSelected(code));
    }
  }

  public componentDidUpdate(prevProps: MultipleCodeSelectorProps) {
    if(this.props !== prevProps) {
      this.setState({adding: false});
    }
  }

  public render() {
    const { options, textDone } = this.props;

    return (<div>
      <DialogExpander
        title={this.props.title}
        onClose={this.props.onClose}
        textDone={textDone}
      >
        {this.renderCodeList(options)}
      </DialogExpander>
    </div>);
  }

  private renderCodeList(options: ComplexValue<number>[]) {

    return (
      <ul className="row align-items-stretch">
        {!options ? <ElementLoader /> : options.map(c => this.renderCode(c))}
      </ul>
    );
  }

  private renderCode(option: ComplexValue<number>) {
    const isSelected = !!this.props.selectedOptions.find(sc => option.value === sc.value);
    const checkbox = { checkedState: isSelected };

    return <SelectOptionButton
      key={`${option.value}`}
      data={option}
      onClick={!isSelected && this.onSelectCode}
      onExpand={undefined}
      checkbox={checkbox}
    />;
  }
}
